var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('TeamProfileCard',{attrs:{"publicView":"","printPreview":"","teamId":_vm.teamId,"sharingUrlId":_vm.sharingUrlId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }